import React, { Component } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";
import config from "../../../../config";

class CreateCurtainRunnerPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: [
        {
          id: "name",
          label: "Curtain Runner Name",
          type: "text",
          tooltip: "Please Enter Curtain Runner Name",
          required: true,
          value: ""
        },
        {
          id: "description",
          label: "Description",
          type: "text",
          tooltip: "Please Enter Runner Description",
          value: ""
        },
        {
          id: "width",
          label: "Runner Width",
          type: "number",
          tooltip: "Please Enter Runner Width",
          value: 0
        },
        {
          id: "drop",
          label: "Runner Drop",
          type: "number",
          tooltip: "Please Enter Runner Height",
          value: 0
        },
        {
          id: "manufacturerId",
          label: "Manufacturer ID",
          type: "AlgoliaSelect",
          index: `${config.algolia.prefix}manufacturers_name_asc`,
          filters: "isDeleted:false",
          value: ""
        },
        {
          id: "associatedServices",
          label: "Associated Services",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_services_fees_name_asc`,
          value: []
        },
        {
          id: "associatedTracks",
          label: "Associated Tracks",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_components_name_asc`,
          filter: " AND type:track",
          value: []
        }
      ]
    };
  }

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  APIMethod = async formData => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      const body = {
        details: {
          name: formData.name,
          description: formData.description,
          width: formData.width,
          drop: formData.drop,
          associatedTracks: formData.associatedTracks,
          associatedServices: formData.associatedServices,
          manufacturerId: formData.manufacturerId
        }
      };
      await API.post("telishadeAPI", "/product/curtain/component/runner", {
        body
      });
      this.props.history.push(`/products/curtains/runner`);
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setAlgoliaLoaderState(false));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  render() {
    return (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Curtain Track"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    );
  }
}

export default connect()(CreateCurtainRunnerPopUp);
